import { FlightSearchResponseItem } from "@qite/tide-client";
import { TideAirport } from "./types";

export interface AlternateRoute {
  language: string;
  path: string;
}

export interface LanguageWithName {
  code: string;
  name: string;
}

export interface Breadcrumb {
  title: string;
  path: string;
}

export interface Dates {
  fromDate?: Date;
  toDate?: Date;
}

export enum MobileFilterType {
  Date = "date",
  OpenJawDate = "openJawDate",
  LocationFrom = "locationFrom",
  LocationTo = "locationTo",
  LocationOpenJawFrom = "locationOpenJawFrom",
  LocationOpenJawTo = "locationOpenJawTo",
  Passenger = "passenger",
}

export enum ActiveInputType {
  From = "from",
  To = "to",
  OpenJawFrom = "openJawFrom",
  OpenJawTo = "openJawTo",
}

export enum FlightTravelClass {
  None = 0,
  Economy = 1,
  PremiumEconomy = 2,
  Business = 4,
  First = 8,
}

export interface DateStruct {
  year: number;
  month: number;
  day: number;
}

export interface FilterValue {
  name: string;
  id: number | string;
  lowestPrice: number;
}

export interface Filters {
  numberOfStops: FilterValue[];
  departureRanges: FilterValue[];
  returnRanges: FilterValue[];
  airlines: FilterValue[];
  departureTravelTimes: FilterValue[];
  returnTravelTimes: FilterValue[];
  providers: FilterValue[];
  fareTypes: FilterValue[];
  flightNumbers: FilterValue[];
}

export interface SortByType {
  field: string;
  direction: "asc" | "desc";
}

export enum DepartureRange {
  Morning = 0,
  Afternoon = 1,
  Evening = 2,
  Night = 3,
}

export enum FilterField {
  DeadlineName = "agentAllotments_paxListDeadline",
  DeadlineTicketing = "agentAllotments_ticketingDate",
  DeadlineDeposit = "agentAllotments_firstDepositDeadline",
  OptionStatus = "status_option",
  BookingStatus = "status_booking",
  TicketedStatus = "status_ticketed",
  CancelledStatus = "status_cancelled",
}

export interface Room {
  adults: number;
  childAges: number[];
}

export interface AirlineProductCode {
  departureAirport: string;
  arrivalAirport: string;
  airlineIata: string;
}

export interface ExtendedFlightSearchResponseItem extends FlightSearchResponseItem {
  requestId: number; // Unique identifier for the search request
  guid: string; // Unique identifier for the item
}

export interface SearchRequest {
  from: TideAirport | undefined;
  to: TideAirport | undefined;
  return: TideAirport | undefined;
  dates: Dates;
  selectedTravelClass: FlightTravelClass | null;
  adults: number;
  kids: number;
  babies: number;
  isLuggageIncluded: boolean;
  isOnlyDirect: boolean;
  flightType: FlightType;
}

export interface Sequence {
  requestId: number;
  sequenceId: number;
}

export interface FilterBarValue {
  field: FilterField;
  text: string;
  numberOfResults: number;
}

export enum FlightType {
  Retour = 0,
  OneWay = 1,
  OpenJaw = 2,
}

export interface PriceGroup {
  paxType: PaxType;
  numberOfPax: number;
  taxPrice: number;
  ticketPrice: number;
}

export type PaxType = "ADULT" | "CHILD" | "INFANT";

export interface SearchState {
  requestId: number | null;
  results: ExtendedFlightSearchResponseItem[];
  sequenceIds: number[];
  lastSequenceId: number | null;
  loading: boolean;
}
